import functions from '../functions.js';
import Slider from "../components/Slider";
import { details } from './details';

$(() => {
    detailsAccommodation.init();
})

const detailsAccommodation = {
    $details: null,
    $form: null,
    form: null,
    params: {
        idList: null,
        objectId: null,
        unitId: null,
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null,
        objectGroupId: null,
        pricelistId: null,
        calcErrorMessages: null,
    },
    init() {

        this.$details = $('.page-type-details-accommodation');
        this.params.objectGroupId = this.$details.attr('data-objectgroupid');

        if(! this.$details[0] && this.params.objectGroupId != 1) {
            return;
        }

        detailsAccommodation.$form = $('.availability-form');
        this.params.objectId = this.$details.attr('data-objectid');

        this.getParams();

        if (this.params.dateFrom && this.params.dateTo) this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        console.log(this.params);

        functions.setFormData(detailsAccommodation.$form[0], this.params);
        this.getCalculation();

        detailsAccommodation.$form.on('submit', e => {
            e.preventDefault();
            $(".spinner-border").removeClass('d-none')
            let params = functions.getFormData($(e.currentTarget));
            functions.setUrlData(params, true);
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.getCalculation();
        });


        $('.btn-booking').on('click', e => {

            const $target = $(e.currentTarget);
            if ( ! $target.attr('href')) {
                e.preventDefault();
                setTimeout(() => {
                    if ( ! $('input[name="dates"]').val()) {
                        $('.datepicker-range')[0]._flatpickr.open();
                    } else {
                        $('.input-guests').first().trigger('click');
                    }
                });
            }
        });

    },

    printDates() {
        $('.date-from').text(functions.formatDate(this.params.dateFrom));
        $('.date-to').text(functions.formatDate(this.params.dateTo));
    },
    getParams() {

        this.params = details.getParams(this.params);
        detailsAccommodation.splitCalendarDates(this.params.dates);
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation() {

        details.getCalculation(this.params)
            .done(response => {
                this.calculationDone(response);
                $(".spinner-border").addClass('d-none')
            }).fail(error => {
                //console.log(error);
            });
    },
    loader($target = null) {
        if ($target) {
            $target.addClass('active');
        } else {
            $('.unit-spinner-block').removeClass('d-none');
            $('.unit-spinner').addClass('active');
        }

        setTimeout(() => {
            if ($target) {
                $target.removeClass('active');
            } else {
                $('.unit-spinner-block').addClass('d-none');
                $('.unit-spinner').removeClass('active');
            }
        }, 800);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.status == 'Active';
    },
    calculationDone(response) {
        if(response.status) {
            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');

                if(this.isBookable(unitData)) {
                    const unitCalc = unitData.calc;
                    const calcItems = unitCalc.items;
                    const total = unitCalc.total;
                    const currencySymbol = unitCalc.currencySymbol;

                    let priceOld = details.getCalcTotalOld(calcItems);

                    if(+priceOld.toFixed(2) > +total.toFixed(2)) {
                        $unit.find('.unit-price-old').removeClass('d-none');
                        $unit.find('.unit-price-old').text(functions.formatMoney(priceOld, 0, '.', ',') + ' ' + currencySymbol);
                        $unit.find('.unit-price-total').addClass('text-danger');
                    } else {
                        $unit.find('.unit-price-old').html('');
                        $unit.find('.unit-price-old').addClass('d-none');
                        $unit.find('.unit-price-total').removeClass('text-danger');
                    }

                    $unit.find('.btn-booking').removeClass('d-none');
                    $unit.find('.btn-soldOut').addClass('d-none');
                    $unit.find('.unit-price-total-label').removeClass('d-none');
                    $unit.find('.unit-price-total').removeClass('d-none');
                    $unit.find('.unit-price-total').text(functions.formatMoney(total, 0, '.', ',') + ' ' + currencySymbol);

                    $unit.find('.btn-booking').attr('href', $unit.find('.btn-booking').attr('data-href'));

                    if($unit.find('.btn-booking').attr('href')) {
                        $unit.find('.btn-booking').attr('href',
                            $unit.find('.btn-booking').attr('href').split('?')[0] +
                            '?unitId=' + unitId +
                            '&dateFrom=' + this.params.dateFrom +
                            '&dateTo=' + this.params.dateTo +
                            '&guests=' + $('[name=guests]').val() +
                            '&addAllOptionals=' + 1 +
                            (this.params.pricelistId ? '&pricelistId=' + this.params.pricelistId : '') +
                            (this.params.partnerId ? '&partnerId=' + this.params.partnerId : '') +
                            (this.params.dynamicPackage ? '&dynamicPackage=' + this.params.dynamicPackage : '') +
                            (this.params.objectGroupId ? '&objectGroupId=' + this.params.objectGroupId : '')
                        );
                    }

                    this.printDates();

                    if ($unit.find('.unit-spinner.active').length) {
                        $unit.find('.unit-price-total-label').addClass('d-none');
                        $unit.find('.unit-price-total').addClass('d-none');
                        $unit.find('.unit-price-old').addClass('d-none');
                    }
                } else {
                    $unit.find('.btn-booking').attr('href', '');
                    $unit.find('.btn-booking').addClass('d-none');
                    $unit.find('.unit-price-total-label').addClass('d-none');
                    $unit.find('.unit-price-total').addClass('d-none');
                    $unit.find('.unit-price-old').addClass('d-none');
                    $unit.find('.btn-soldOut').removeClass('d-none');
                }
            });
        }
    }
};
